/** Avoid JSON.parse on empty 204 No Content bodies (common on DELETE). */
export const safeJsonTransformResponse = [
  (data, _headers, status) => {
    if (status === 204 || data === '' || data == null) {
      return null;
    }
    if (typeof data === 'string') {
      try {
        return JSON.parse(data);
      } catch {
        return data;
      }
    }
    return data;
  },
];
